module.exports = __webpack_public_path__ + "img/logo-new-full.4cf1a0bd.png";